export const useLoaderStore = defineStore('loader', () => {
  const ready = reactive({
    seo: false,
    rubrics: false,
    expList: false,
  });

  const is404 = ref(false);

  const isFiltersLoading = computed(() => {
    const notReady = [];
    for (const [key, isReady] of Object.entries(ready)) {
      if (!isReady) {
        notReady.push(key);
      }
    }

    return notReady.length > 0;
  });

  function check404({ response }: { response: Response }) {
    if (response.status === 404) {
      is404.value = true;
    }
  }

  return {
    ready,
    is404,

    isFiltersLoading,

    check404,
  };
});
